import React from 'react';
import { FormulaComponentProps } from '../../types/index';

export const DiseaseSpecificityIndex: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const mathML = `
    <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
      <mrow>
        <mi mathvariant="italic">DSI</mi>
        <mo>=</mo>
        <mfrac>
          <mrow>
            <msub>
              <mi mathvariant="italic">log</mi>
              <mn>2</mn>
            </msub>
            <mo stretchy="false" form="prefix">(</mo>
            <mfrac>
              <msub>
                <mi>N</mi>
                <mi>d</mi>
              </msub>
              <msub>
                <mi>N</mi>
                <mi>T</mi>
              </msub>
            </mfrac>
            <mo stretchy="false" form="postfix">)</mo>
          </mrow>
          <mrow>
            <msub>
              <mi mathvariant="italic">log</mi>
              <mn>2</mn>
            </msub>
            <mo stretchy="false" form="prefix">(</mo>
            <mfrac>
              <mn>1</mn>
              <msub>
                <mi>N</mi>
                <mi>T</mi>
              </msub>
            </mfrac>
            <mo stretchy="false" form="postfix">)</mo>
          </mrow>
        </mfrac>
      </mrow>
    </math>
  `;

  return (
    <div 
      className={className} 
      style={style}
      dangerouslySetInnerHTML={{ __html: mathML }}
    />
  );
};